import store from "../../config/store";
import { SiafLiteApiStream, SiafLiteApiRepository } from "../../external";
class ProdutosService {
  constructor() {
    this.urlBase = "/estoque/produtos";
    this.urlBaseEvent = `/event${this.urlBase}`;
    this.urlBaseCompleta = `${store.baseUrl}${this.urlBase}`;
  }

  getAll(filtros) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filtros);
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  cadastrarListaProdutos(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/lista`).post(body);
  }

  getAllProdutosFornecedores(filtros) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/fornecedores`).get(
      filtros
    );
  }

  getAllProdutosSimples(filtros) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/simples`).get(
      filtros
    );
  }

  getAllProdutosByCodigo(filtros) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/codigo`).get(
      filtros
    );
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  getByIdProdutoEstoqueInformacaoEmpresas(id) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/estoque-informacao-empresas`
    ).getById(id);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  reajustePrecoProduto(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/reajuste-preco`
    ).patch(body);
  }

  atualizarLista(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).putBase(
      "/lista/nf-entrada",
      body
    );
  }

  atualizarAplicacoes(id, body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/aplicacoes`).put(
      id,
      body
    );
  }

  desativar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).putBase(
      `/desativar/${id}`
    );
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  getByCodbar(codbar) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/codbar/${codbar}`
    ).get();
  }

  validarCodigoBarras(codbar) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/codigobarras/${codbar}`
    ).get();
  }

  validarListaCodigoBarras(listaCodbar) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/codigobarras/lista`
    ).patch(listaCodbar);
  }

  validarTagVinculada(tagId) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/tag-vinculada/${tagId}`
    ).get();
  }

  validarCodigoBarrasId(id, codbar) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/codigobarras/${id}/${codbar}`
    ).get();
  }

  atualizarGrade(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body, "grade");
  }

  getConfispedApi(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/confisped`).patch(
      body
    );
  }

  createPrecificacao(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).putBase(
      "/precificar-produto",
      body
    );
  }

  getRelatorioResumido(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/resumido`
    ).path(body);
  }

  getRelatorioDetalhado(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/detalhado`
    ).path(body);
  }

  getInventarioDeEstoque(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/inventario`
    ).path(body);
  }

  // getRelatorioEstoqueFinanceiro(body) {
  //   return new SiafLiteApiRepository(
  //     `${this.urlBaseEvent}/relatorios/estoque-financeiro`
  //   ).patch(body);
  // }

  // getCustoMercadoriaVendida(body) {
  //   return new SiafLiteApiRepository(
  //     `${this.urlBaseEvent}/relatorios/custo-mercadoria-vendida`
  //   ).patch(body);
  // }

  getRelatorioDashboardCmv(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/relatorios/dashboard-cmv`
    ).patch(body);
  }

  // getAnaliseProdutosVendidos(body) {
  //   return new SiafLiteApiRepository(
  //     `${this.urlBaseEvent}/relatorios/analise-produtos-vendidos`
  //   ).patch(body);
  // }

  getMovimentacaoEstoque(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/movimentacao-estoque`
    ).patch(body);
  }

  getRelatorioEstoqueFinanceiro(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/estoque-financeiro`
    ).path(body);
  }

  getCustoMercadoriaVendida(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/custo-mercadoria-vendida`
    ).path(body);
  }

  getAnaliseProdutosVendidos(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/analise-produtos-vendidos`
    ).path(body);
  }
}

export default ProdutosService;
